import React from "react";
import { SRLWrapper } from "simple-react-lightbox";

export const Oppo = () => {
  let pictures = [];
  for (let i = 1; i <= 9; i++) {
    pictures.push(
      require(`../../../Assets/img/photos/commissions/oppo/oppo-indonesia-${i}.jpg`)
    );
  }
  return (
    <div className="commissions-content">
      <p className="commissions-description">
        Uzbekistan, sebuah Negara pecahan Uni Soviet yang terbilang masih sangat
        muda. Menyuarakan untuk merdeka di tahun 1991, kini Uzbekistan berdiri
        mandiri, dengan segala peninggalan sejarah yang tak lekang oleh waktu.
        <br />
        <br />
        Melalui device OPPO Reno dengan fitur terbaru mereka yang memasukkan
        teknologi hybrid 10x zoom ke dalam sebuah smartphone, it’s genius! Untuk
        moment catcher yang spontan seperti aku, smartphone ini jadi sahabat
        traveling terbaik. Aku banyak memotret momen-momen spontan, detail
        ornamen pada bangunan kuno, juga momen ketika malam menyapa, semuanya
        dalam sentuhan jari, namun hasilnya sangat memuaskan.
        <br />
        <br />
        Aku juga hanya cukup mengisi ulang daya baterai satu kali dalam sehari
        dan itupun hanya memakan waktu 60-80 menit hingga 100%! OPPO Reno 10x
        zoom ini memiliki teknologi VOOC 3.0, dengan pengisian daya baterai
        cepat, sangat membantu untuk aku yang sangat aktif di sosial media,
        video, dan foto di Instagram. Setelah semuanya siap, aku memulai
        perjalanan dari Barat ke Timur, dari kota yang masih sangat menjungjung
        tinggi peradaban di masa lalu, hingga kota yang lebih modern.
      </p>
      <SRLWrapper>
        <div className="portfolio-pictures-row-portrait">
          {pictures.map((picture, index) => {
            return <img key={`oppo-${index}`} src={picture} />;
          })}
        </div>
      </SRLWrapper>
    </div>
  );
};

export default Oppo;
